import { useCallback } from 'react';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { CrossTabNavigationOptions } from './useCrossTabNavigation';

export const useTabNavigation = () => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const location = useLocation();
  const baseUrl = path.replace(':tab', '');

  const handleTabChange = useCallback(
    (value: string) => {
      // Clean up navigation-specific parameters when using tab navigation
      const searchParams = new URLSearchParams(location.search);
      searchParams.delete('from');
      searchParams.delete('fromUrl');

      history.push({
        pathname: baseUrl + value,
        search: searchParams.toString(),
      });
    },
    [baseUrl, history, location.search],
  );

  const handleCrossTabNavigation = useCallback(
    ({ targetTab, sourceTab, additionalParams = {} }: CrossTabNavigationOptions) => {
      const searchParams = new URLSearchParams(location.search);

      // Add cross-tab navigation parameters
      searchParams.set('from', sourceTab);
      searchParams.set('fromUrl', encodeURIComponent(location.pathname + location.search));

      // Add any additional parameters (like memberIds, filters, etc.)
      Object.entries(additionalParams).forEach(([key, value]) => {
        searchParams.set(key, value);
      });

      history.push({
        pathname: baseUrl + targetTab,
        search: searchParams.toString(),
      });
    },
    [baseUrl, history, location],
  );

  return {
    handleTabChange,
    handleCrossTabNavigation,
    baseUrl,
  };
};
